/** React binding for the module-level debug store (src/api/debugMode.ts). */
import { useSyncExternalStore } from 'react';

import {
  clearDebugEntries,
  getDebugEntries,
  isDebugEnabled,
  setDebugEnabled,
  subscribeDebug,
  type DebugRequestEntry,
} from '@/api/debugMode';

export function useDebugMode(): {
  enabled: boolean;
  setEnabled: (value: boolean) => void;
  entries: readonly DebugRequestEntry[];
  clear: () => void;
} {
  const enabled = useSyncExternalStore(subscribeDebug, isDebugEnabled);
  const entries = useSyncExternalStore(subscribeDebug, getDebugEntries);
  return { enabled, setEnabled: setDebugEnabled, entries, clear: clearDebugEntries };
}
